import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-arrowdown2",
  "use": "rt-base-arrowdown2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-arrowdown2\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 575.8L300.3 364.1c-15.6-15.6-41-15.6-56.6 0-15.6 15.6-15.6 41 0 56.6l240 240c3.9 3.9 8.4 6.8 13.2 8.8 8.4 3.4 17.8 3.8 26.5 1.3 1.3-0.4 2.4-0.8 3.7-1.3 4.8-1.9 9.3-4.9 13.2-8.8l240-240c15.6-15.6 15.6-41 0-56.6-15.6-15.6-41-15.6-56.6 0L512 575.8z\" p-id=\"2689\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/arrowdown2.svg
// module id = 1683
// module chunks = 137